var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad.AdImage)?_c('div',{staticClass:"floating-ad"},[_c('img',{attrs:{"src":_vm.ad.AdImage},on:{"click":function($event){_vm.ad.JumpUrl && _vm.$util.jumpUrl(_vm.ad.JumpUrl)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }